import { CashFundAccountModule } from "pages/Cash/components/CashFundAccount/CashFundAccountModule";
import React from "react";

const CashFundAccount = props => {
  if (props.showFundActionModule) {
    return   <CashFundAccountModule
      modulePosition={props.modulePosition}
      handleOpenFrozenModal={props.handleOpenFrozenModal}
      frozenCard={props.frozenCard}
      {...props}
    />
  } else {
    return '';
  }

}

export default CashFundAccount;